import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import { routes } from "../../../utlis/admin/routes.utlis";
import ApiService from "../../../core/services/ApiService";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
import { encode } from "base-64";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { totalPageCalculator, LIMIT } from "../../../utlis/common.utlis";

const Page = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    name: "",
    status: "",
    startDate: null,
    endDate: null,
    month: "",
    quarter: "",
    year: "",
  });

  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [dateType, setDateType] = useState("");

  const handleFilterChange = (e, date = null) => {
    const { name, value } = e.target || {};
    const formattedDate = date ? moment(date).format("yyyy-MM-DD") : null;

    // Update the filters state
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: date === null ? value : formattedDate, // Use `value` for non-date fields, `formattedDate` for date fields
    }));
  };

  const handleSearch = () => {
    //console.log("Filters on Search:", filters); // Debugging
    fetchFilteredData(filters); // Trigger search with current filters
  };

  const handleReset = () => {
    const resetFilters = {
      name: "",
      status: "",
      startDate: null,
      endDate: null,
      month: "",
      quarter: "",
      year: "",
    };

    setFilters(resetFilters);
    setDateType("");
    setPageNum(1);

    //console.log("Filters after Reset:", resetFilters);
    fetchFilteredData(resetFilters);
  };

  const fetchFilteredData = async (filterParams) => {
    const query = new URLSearchParams({
      page: pageNum,
      limit: LIMIT,
      search: filterParams.name,
      status: filterParams.status,
      startDate: filterParams.startDate,
      endDate: filterParams.endDate,
      month: filterParams.month,
      quarter: filterParams.quarter,
      year: filterParams.year,
    }).toString();

    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(`${api.userList}?${query}`);
    if (response.data.status && response.data.statusCode === 200) {
      setUsers(response.data.data.users);
      setTotal(response.data.data.total);
    } else {
      setUsers([]);
    }
    setLoading(false);
  };

  const handleDateTypeChange = (e) => {
    const value = e.target.value;

    // Clear all other date-related fields when selecting a new date_type
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: null,
      endDate: null,
      month: value === "month" ? prevFilters.month : "",
      quarter: value === "quarter" ? prevFilters.quarter : "",
      year: value === "year" || value === "month" || value === "quarter" ? prevFilters.year : "",
    }));

    setDateType(value);
  };

  useEffect(() => {
  window.scrollTo(0, 0);
  const fetchData = async () => {
    const query = new URLSearchParams({
      page: pageNum,
      limit: LIMIT,
      /*
      search: filters.name,
      status: filters.status,
      startDate: filters.startDate,
      endDate: filters.endDate,
      month: filters.month,
      quarter: filters.quarter,
      year: filters.year,
      */
    }).toString();

    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(`${api.userList}?${query}`);
    if (response.data.status && response.data.statusCode === 200) {
      setUsers(response.data.data.users);
      setTotal(response.data.data.total);
    } else {
      setUsers([]);
    }
    setLoading(false);
  };

  fetchData();
}, [pageNum]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="carenetwork-section">
          <div className="care-title-header1">
            <h2 className="heading-title mb-3">User Management</h2>
            <div className="cc-search-filter 100 mb-2">
              <div className="row g-2">

                {/* Search by Name */}
                <div className="col-md-2">
                  <div className="form-group search-form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control ps-3"
                      placeholder="Search"
                      value={filters.name}
                      onChange={handleFilterChange}
                    />
                  </div>
                </div>

                {/* Filter by Status */}
                <div className="col-md-2">
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="status"
                      value={filters.status}
                      onChange={handleFilterChange}
                    >
                      <option value="">Select Status</option>
                      <option value="0">Pending Users</option>
                      <option value="1">Active Users</option>
                      <option value="2">Inactive Users</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="date_type"
                      value={dateType}
                      onChange={handleDateTypeChange}
                    >
                      <option value="">Choose Date Range</option>
                      <option value="date">Date</option>
                      <option value="month">Month</option>
                      <option value="quarter">Quarter</option>
                      <option value="year">Year</option>
                    </select>
                  </div>
                </div>

                {/* Conditionally Render Fields Based on Date Type */}
                {dateType === "date" && (
                  <div className="col-md-4 d-flex">
                    <div className="form-group">
                      {/* From Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.startDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "startDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="From Date"
                      />
                    </div> &nbsp; &nbsp;
                    <div className="form-group">
                      {/* To Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.endDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "endDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="To Date"
                      />
                    </div>
                  </div>
                )}

                {dateType === "month" && (
                  <>
                    <div className="col-md-2">
                      <div className="form-group">
                        <select
                          className="form-control"
                          name="month"
                          value={filters.month}
                          onChange={handleFilterChange}
                        >
                          <option value="">Select Month</option>
                          <option value="1">January</option>
                          <option value="2">February</option>
                          <option value="3">March</option>
                          <option value="4">April</option>
                          <option value="5">May</option>
                          <option value="6">June</option>
                          <option value="7">July</option>
                          <option value="8">August</option>
                          <option value="9">September</option>
                          <option value="10">October</option>
                          <option value="11">November</option>
                          <option value="12">December</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <select
                          className="form-control"
                          name="year"
                          value={filters.year}
                          onChange={handleFilterChange}
                        >
                          <option value="">Select Year</option>
                          {Array.from({ length: 10 }, (_, i) => {
                            const year = new Date().getFullYear() - i;
                            return (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </>
                )}

                {dateType === "quarter" && (
                  <>
                    <div className="col-md-2">
                      <div className="form-group">
                        <select
                          className="form-control"
                          name="quarter"
                          value={filters.quarter}
                          onChange={(e) => handleFilterChange(e)}
                        >
                          <option value="">All Quarters</option>
                          <option value="1">Q1 (Jan - Mar)</option>
                          <option value="2">Q2 (Apr - Jun)</option>
                          <option value="3">Q3 (Jul - Sep)</option>
                          <option value="4">Q4 (Oct - Dec)</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <select
                          className="form-control"
                          name="year"
                          value={filters.year}
                          onChange={(e) => handleFilterChange(e)}
                        >
                          <option value="">Select Year</option>
                          {Array.from({ length: 10 }, (_, i) => {
                            const year = new Date().getFullYear() - i;
                            return (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </>
                )}

                {dateType === "year" && (
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        value={filters.year}
                        onChange={(e) => handleFilterChange(e)}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}

                <div className="col-md-2">
                  <div className="form-group">
                    <button
                      className="btn btn-gr p-1"
                      onClick={handleSearch}
                    >
                      <i className="cc-input-group-text mdi mdi-magnify"></i>
                    </button> &nbsp;
                    <button
                      className="btn btn-re p-1"
                      onClick={handleReset}
                    >
                      <i className="cc-input-group-text mdi mdi-restore"></i>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="carenetwork-content cc-table-card">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th> Name </th>
                    <th> Contact Number </th>
                    <th> Email ID </th>
                    <th> Registered On </th>
                    <th> Status </th>
                    <th> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {users.length !== 0 ? (
                    users.map((ele, indx) => {
                      return (
                        <tr key={indx}>
                          <td className="text-capitalize">
                            {ele.profile_image === null ||
                              ele.profile_image === "" ||
                              ele.profile_image === undefined ? (
                              <img src={NoImage} alt="" className="me-3" />
                            ) : (
                              <img
                                src={ele.profile_image}
                                alt=""
                                className="me-3"
                              />
                            )}
                            {ele.name ?? "NA"}
                          </td>
                          <td> {ele.mobile ?? "NA"} </td>
                          <td className="text-lowercase">
                            {" "}
                            {ele.email ?? "NA"}{" "}
                          </td>
                          <td>
                            {moment(ele.created_date).format("MM-DD-yyyy")}
                          </td>
                          <td> {ele.status} </td>
                          <td>
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.userManagementDetail, {
                                  state: {
                                    id: encode(ele.userid),
                                  },
                                });
                              }}
                            >
                              <label
                                style={{ cursor: "pointer" }}
                                className="badge badge-gradient-success"
                              >
                                <i className="fa fa-eye"></i>
                              </label>
                            </Link>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="6">
                        <div>
                          <p>No users found</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="d-flex align-items-center justify-content-center mt-3">
                {users.length !== 0 ? (
                  <div className="care-table-pagination">
                    <ul className="care-pagination">
                      {pageNum !== 1 && (
                        <li
                          className="disabled"
                          id="example_previous"
                          onClick={() => setPageNum(pageNum - 1)}
                        >
                          <Link
                            to=""
                            aria-controls="example"
                            data-dt-idx="0"
                            tabIndex="0"
                            className="page-link"
                          >
                            Previous
                          </Link>
                        </li>
                      )}

                      {totalPageCalculator(total, LIMIT).length === 1
                        ? null
                        : totalPageCalculator(total, LIMIT).map(
                          (pageNo, indx) => {
                            return (
                              <li
                                className={pageNo === pageNum ? "active" : ""}
                                key={indx}
                                onClick={() => setPageNum(pageNo)}
                              >
                                <Link to="" className="page-link">
                                  {pageNo}
                                </Link>
                              </li>
                            );
                          }
                        )}

                      {pageNum !== Math.ceil(total / LIMIT) && (
                        <li
                          className="next"
                          id="example_next"
                          onClick={() => setPageNum(pageNum + 1)}
                        >
                          <Link
                            to=""
                            aria-controls="example"
                            data-dt-idx="7"
                            tabIndex="0"
                            className="page-link"
                          >
                            Next
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
